<template>
  <div>
    <!-- USSD Modal Structure -->
    <div id="ussd" class="modal services">
      <div v-if="!USSDverified">
        <div class="modal-header">
          <a
            class="modal-close waves-effect btn-small waves-green right"
            @click="removeAlert"
            >x</a
          >
          <img src="ui/img/logo.png" width="18%" class="responsive-img" />
        </div>
        <div class="modal-content">
          <h5>Pay Via USSD Code</h5>
          <div class="row">
            <div class="input-field col s10 offset-s1 m6 offset-m3">
              <select
                class="browser-default"
                v-model="ussdoption"
                @change="ussdCode(ussdoption)"
              >
                <option value="" disabled selected>Select option</option>
                <option
                  v-for="(bank, index) in banks"
                  :key="index"
                  :value="bank.id"
                  >{{ bank.bank }}</option
                >
              </select>
            </div>
          </div>
          <div class="row">
            <h5>
              <strong>{{ ussdValue }}</strong>
            </h5>
            <p @click="openUSSD" class="click" style="cursor: pointer;">
              Click to dial
            </p>
            <div v-if="confirm">
              <div class="alert alert-info">
                Please wait a minute (1) before clicking the confirm button
                after payment has been completed.
              </div>
              <br />
              <a
                class="waves-effect waves-green btn-small"
                style="margin-right: 10px"
                @click.prevent="verifyUSSD"
                >Confirm payment</a
              >
              <a
                class="modal-close waves-effect waves-green btn-small"
                style="margin-right: 10px"
                @click="removeAlert"
                >Change payment option</a
              >
            </div>
            <div v-if="USSDvending">
              <img src="ui/img/loading.svg" alt="Time Loader" />
              <p><i>Loading...</i></p>
            </div>
            <div class="alert alert-warning"></div>
            <a
              v-show="alertError"
              class="modal-close waves-effect waves-green btn-small"
              style="margin-right: 10px"
              @click="removeAlert"
              >Change payment option</a
            >
          </div>
        </div>
      </div>
      <div class="modal-content" v-else>
        <img src="ui/img/success.png" width="12%" class="responsive-img" />
        <h6>Your order has been completed sucessfully.</h6>
        <h6><strong>Transaction Details</strong></h6>
        <p><strong>Transaction Ref:</strong> {{ transactionID }}</p>
        <p><strong>Payment Ref:</strong> {{ reply.payment_ref }}</p>
        <div v-if="service == 'electricity'">
          <p><strong>Order Info:</strong> {{ reply.title }}</p>
          <p>
            <strong>
              <span class="token">Token: {{ reply.token }}</span>
            </strong>
          </p>
          <p>
            <span class="token">Units: {{ reply.units }}</span>
          </p>
        </div>
        <a
          class="modal-close waves-effect waves-green btn-small"
          style="margin-right: 10px"
          @click="resetArea"
          >Close</a
        >
      </div>
    </div>
    <!-- USSD Modal Structure -->
  </div>
</template>
<script>
export default {
  props: ['transactionID', 'coralCode', 'service'],
  data() {
    return {
      ussdValue: '',
      alertError: false,
      ussdoption: '',
      confirm: false,
      fields: {
        action: 'get_banks'
      },
      verify: {
        action: 'confirm_ussd'
      },
      USSDvending: false,
      banks: [],
      USSDverified: false,
      reply: {}
    }
  },
  created() {
    this.getBanks()
  },
  mounted() {
    $('.alert-warning').hide()
    $('.click').hide()
  },
  methods: {
    openUSSD() {
      var code = this.ussdValue.replace('Dial ', '')
      window.open('tel:' + code, '_self')
    },
    getBanks() {
      this.fields.passcode = this.hash(this.fields.action)
      this.axios
        .post('https://irecharge.com.ng/api/money/ussd_banks.php', this.fields)
        .then(response => {
          if (response.data.status == '0') {
            this.banks = response.data.banks
          } else {
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'info' })
          }
          if (response.data.message == 'Unauthorized Access') {
            $('.toast').hide()
            M.toast({
              html: 'We could not verify, please try again.',
              classes: 'error'
            })
          }
        })
        .catch(error => {
          $('.toast').hide()
          // M.toast({ html: 'Could not fetch banks, check network & reload page.', classes: 'error' })
        })
    },
    ussdCode(option) {
      var trans_id = this.coralCode
      this.banks.forEach(bank => {
        if (bank.id == option) {
          this.ussdValue = `Dial ${bank.code}${trans_id}#`
        }
      })
      $('.click').show()
      this.confirm = true
    },
    verifyUSSD() {
      $('.alert-warning').hide()
      this.ussdValue = ''
      this.USSDvending = true
      this.confirm = false
      $('.click').hide()
      this.verify.transaction_id = this.transactionID
      this.verify.service = this.service
      this.verify.passcode = this.hash(this.verify.transaction_id.toString())
      this.axios
        .post('https://irecharge.com.ng/api/misc/confirm_ussd.php', this.verify)
        .then(response => {
          if (response.data.status == '0') {
            this.reply.payment_ref = response.data.payment_ref
            if (this.service == 'electricity') {
              this.reply.title = response.data.title
              this.reply.token = this.spaceToken(response.data.token, 4).join(
                '-'
              )
              this.reply.units = response.data.units
            }
            $('.toast').hide()
            M.toast({ html: response.data.message, classes: 'success' })
            this.USSDverified = true
            this.USSDvending = false
          } else {
            this.USSDvending = false
            this.alertError = true
            $('.alert-warning').text(response.data.message)
            $('.alert-warning').show()
          }
        })
        .catch(error => {
          $('.toast').hide()
          M.toast({
            html: 'Could not send request, check network.',
            classes: 'error'
          })
          this.USSDvending = false
          this.confirm = true
          $('.click').hide()
        })
    },
    removeAlert() {
      $('.alert-warning').hide()
      this.ussdValue = ''
      this.ussdoption = ''
      this.alertError = false
      this.confirm = false
      $('.click').hide()
    },
    resetArea() {
      this.confirm = true
      $('.click').hide()
      this.USSDvending = false
      this.USSDverified = false
      this.$emit('ussd-complete')
    },
    emptyFormInputs() {
      const formInput = document.querySelectorAll('#form input')
      const formSelect = document.querySelectorAll('#form select')
      formInput.forEach(function(item) {
        item.value = ''
      })
      formSelect.forEach(function(item) {
        item.value = 'Select option'
      })
    },
    spaceToken(str, n) {
      var ret = []
      var i
      var len
      for (i = 0, len = str.length; i < len; i += n) {
        ret.push(str.substr(i, n))
      }
      return ret
    },
    disableFormInputs(option) {
      const formInput = document.querySelectorAll('#form input')
      const formSelect = document.querySelectorAll('#form select')
      formInput.forEach(function(item) {
        item.disabled = option
      })
      formSelect.forEach(function(item) {
        item.disabled = option
      })
    },
    revert() {
      const formInput = document.querySelector('#leftContainment')
      formInput.style.display = 'block'
      this.proccedBtn = false
      this.showSummary = false
      this.disableFormInputs(false)
    },
    hash(ref) {
      let passcode = '123NDSx'
      let encrypted = CryptoJS.HmacSHA512(ref, passcode)
      return encrypted.toString()
    }
  }
}
</script>
<style scoped>
span.token {
  font-size: 22px;
}
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-top: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}
</style>
